/**
 * Names for the places a card can be on screen, so a move can fly a card from one to the other. The board views (mat
 * and table) and the hand mark their places with these (Anchor); FlyingCards measures them.
 */
export const anchors = {
  active: (userId) => `${userId}:active`,
  bench: (userId, position) => `${userId}:bench:${position}`,
  deck: (userId) => `${userId}:deck`,
  discard: (userId) => `${userId}:discard`,
  /** Where a Trainer lies face up while it's played (Board/TrainerInPlay). */
  play: (userId) => `${userId}:play`,
  prize: (userId, position) => `${userId}:prize:${position}`,
  /** The whole hand: your tray, or the opponent's hand count. */
  hand: (userId) => `${userId}:hand`,
  /** One card in your own hand, by its place in the hand (pivot_id). */
  handCard: (userId, pivotId) => `${userId}:hand:${pivotId}`,
};

/** Places where a card shows, as opposed to the opponent's hand count: a flying card lands on these at full size. */
export const isCardPlace = (name) => !/:hand$/.test(name);

/** Places whose card waits for the flying one: hidden until it lands, so it doesn't appear early. */
export const waitsForLanding = (name) => /:(active|bench:\d+|hand:\d+|discard|prize:\d+)$/.test(name);
